import * as Papa from "papaparse";

export const parserConfig = Object.seal({
    header: true,
    encoding: "",
    worker: false, //to keep page active set true
    skipEmptyLines: true,
    fastMode: false, // works only if no " provided
    delimitersToGuess: [";", ",", "\t", "|", Papa.RECORD_SEP, Papa.UNIT_SEP],
});
